import { render, staticRenderFns } from "./interfaceSetupSon.vue?vue&type=template&id=c92cf0a8&"
import script from "./interfaceSetupSon.vue?vue&type=script&lang=js&"
export * from "./interfaceSetupSon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports